import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CampaignPageContent } from '@uw/core/models/campaign.model';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Observable, mergeMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WelcomePageContentResolver  {

  constructor(private campaignServer: CampaignService,
     private campaignStateService: CampaignStateService){
  }
  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Map<string,CampaignPageContent>> {
    const cguid = route.paramMap.get("cguid") ?? localStorage.getItem('current-campaign');
    return this.campaignServer.getPageContent(cguid ?? '', 'generic').pipe(mergeMap(_c=> this.campaignServer.getPageContent(cguid ?? '', 'welcome')));
  }
}
